import { useState } from "react";

import Item from "./Item";
import { useAuth } from "../context/AuthContext";
import {
  arrowDown,
  folder as myFolder,
  access,
  trash,
  removeAccess,
} from "../assets";
import { deleteFolder, removeAccessToFolder, shareFolder } from "../database";
import Avatar from "./utils/Avatar";

type ItemFolderProps = {
  id: string;
  folder: any;
  openItemForm: () => void;
  handleSelectedItem: (item: any) => void;
  items: any[];
  shared?: boolean;
};

const ItemFolder = ({
  id,
  folder,
  shared,
  openItemForm,
  handleSelectedItem,
  items = [],
}: ItemFolderProps) => {
  const accessTo = folder?.accessTo || [];
  const { authUser } = useAuth();
  const [isExpanded, setIsExpanded] = useState(false);
  const [emailInputBox, setEmailInputBox] = useState(false);
  const [email, setEmail] = useState("");
  const [showAccess, setShowAccess] = useState(false);

  const toggleFolderExpansion = () => {
    setIsExpanded(!isExpanded);
    if (emailInputBox) {
      setEmailInputBox(false);
      setEmail("");
    }
    if (showAccess) {
      setShowAccess(false);
    }
  };

  const handleShare = async () => {
    if (!email) return;

    // check if email is valid
    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(email)) {
      return window.alert("Please enter a valid email address");
    }

    try {
      await shareFolder(id, email);
      setEmailInputBox(false);
      setEmail("");
    } catch (err: any) {
      window.alert(err.message);
    }
  };

  const handleRemoveAccess = async () => {
    if (!email) return;
    try {
      await removeAccessToFolder(id, email);
      setShowAccess(false);
      setEmail("");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className='folder'>
      <div onClick={toggleFolderExpansion} className='folder-box'>
        <h4 className='flex' style={{ gap: 4 }}>
          <img src={myFolder} alt='folder' />
          {folder?.name} ({items.length}){" "}
          {shared && <Avatar text={folder?.createdBy} />}
        </h4>
        <span className='flex' style={{ gap: 4 }}>
          {!shared && (
            <>
              <img
                src={trash}
                alt='trash icon'
                onClick={(e) => {
                  e.stopPropagation();
                  // alert to confirm
                  const consent: any = window.confirm(
                    "Are you sure you want to delete this folder? The items inside will be deleted as well."
                  );
                  if (consent) {
                    deleteFolder(id, authUser?.email);
                  }
                }}
              />
              <img
                src={access}
                alt='access'
                onClick={(e) => {
                  e.stopPropagation();
                  if (showAccess) {
                    setShowAccess(false);
                  }
                  if (isExpanded) {
                    setIsExpanded(false);
                  }

                  setEmailInputBox(!emailInputBox);
                  setEmail("");
                }}
              />
              <img
                src={removeAccess}
                alt='remove access'
                onClick={(e) => {
                  e.stopPropagation();
                  if (emailInputBox) {
                    setEmailInputBox(false);
                    setEmail("");
                  }
                  if (isExpanded) {
                    setIsExpanded(false);
                  }

                  setShowAccess(!showAccess);
                }}
              />
            </>
          )}
          <img
            src={arrowDown}
            alt='arrow down'
            style={{
              transform: isExpanded ? "rotate(-180deg)" : "rotate(0deg)",
            }}
          />
        </span>
      </div>
      {isExpanded &&
        items?.map((item: any) => (
          <Item
            key={item.id}
            item={item}
            openItemForm={openItemForm}
            handleSelectedItem={handleSelectedItem}
            isFolderCreated={folder?.createdBy === authUser?.email}
            child
          />
        ))}
      {emailInputBox && (
        <div className='folder-form'>
          <input
            type='email'
            placeholder='Email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type='submit' onClick={handleShare}>
            Send
          </button>
        </div>
      )}
      {showAccess && (
        <div className='folder-form'>
          <select value={email} onChange={(e) => setEmail(e.target.value)}>
            <option value=''>Select an email</option>
            {accessTo?.map((email: any) => (
              <option key={email} value={email}>
                {email}
              </option>
            ))}
          </select>
          <button onClick={handleRemoveAccess}>Remove</button>
        </div>
      )}
    </div>
  );
};

export default ItemFolder;
